/* src/app/warehousing/pages/locations-label/locations-label.component.scss */
/*# sourceMappingURL=locations-label.component.css.map */
